import { Serializer } from "jsonapi-serializer";
import { CreateMailsTaskInfo, CreateMailTaskRequest } from "../../api/typings/Mails";

export async function getCreateMailTaskData(data: CreateMailsTaskInfo): Promise<CreateMailTaskRequest> {
  return new Serializer("mails_tasks", {
    keyForAttribute: "snake_case",
    attributes: ["mail_template_id", "mail_template_data"],
  }).serialize(data);
}
